import React, { useEffect, useState } from 'react';
import { postAPI, reinitialiseAPI } from 'store/apiReducer';
import * as PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import SimpleTable from 'components/Commun/Table/SimpleTable';
import { connect } from 'react-redux';
import { Container, Row, Col, LoaderMi } from '@si-armes/dsfr-react';
import BoutonEtape from 'components/form/boutonsEtape/BoutonEtape';
import {
    API_AJOUTER_ARME_MANQUANTE,
    CONTEXT_AJOUTER_ARME_MANQUANTE,
} from 'constants/apiUrls.constants';
import usagerClientReducer from 'store/usagerReducer';

const SignalerArmeManquanteEtape2 = ({
    reinitialiseApi,
    postApi,
    dataSignalerArmeManquante,
    etapePrecedente,
    etapeSuivante,
    dataReferentielElementArme,
    dataGdr,
    isLoadingArmeManquanteAjout,
    messageReponse,
}) => {
    const hookForm = useForm({
        mode: 'onSubmit',
    });
    const { handleSubmit } = hookForm;
    const [dataArmeManquanteDisplay, setDataArmeManquanteDisplay] = useState([]);
    const header = [
        'N° RGA',
        'N° de série',
        'Type',
        'Marque',
        'Modèle',
        'Calibre canon 1',
        'Calibre canon 2',
        'Classement',
    ];

    const finEtape = () => {
        etapeSuivante();
    };

    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        setDataArmeManquanteDisplay([
            dataGdr.numeroRGA,
            dataSignalerArmeManquante.nouveauNumeroSerie ?? 'Pas de n° de série',
            dataGdr.type,
            dataGdr.marque,
            dataGdr.modele,
            dataGdr.canonUn ? dataGdr.canonUn.libelleCalibre : null,
            dataGdr.canonDeux ? dataGdr.canonDeux.libelleCalibre : null,
            dataGdr.classementFrancais,
        ]);
    }, []);

    const onSubmit = async () => {
        if (isSubmitting) return;
        const listeElementArmeManquante = [];
        setIsSubmitting(true);

        if (dataReferentielElementArme.typeElementArmeReferentielArme) {
            dataReferentielElementArme.typeElementArmeReferentielArme.forEach((element) => {
                if (dataSignalerArmeManquante[`elementArme-${element.id}`]) {
                    listeElementArmeManquante.push({
                        idReferentiel: element.id,
                        numeroSerie: dataSignalerArmeManquante[`elementArme-${element.id}`],
                    });
                }
            });
        }

        const detenteurArmeManquanteInput = {
            numeroRga: dataSignalerArmeManquante.nouveauNumeroRga,
            hasNumeroSerie: !dataSignalerArmeManquante.hasNumeroSerie,
            numeroSerie: !dataSignalerArmeManquante.hasNumeroSerie
                ? dataSignalerArmeManquante.nouveauNumeroSerie
                : null,
            dateAcquisition: dataSignalerArmeManquante.dateAcquisitionArme,
            isNeutralisee: !!dataSignalerArmeManquante.isNeutralisee,
            dateNeutralisation: dataSignalerArmeManquante.isNeutralisee
                ? dataSignalerArmeManquante.dateNeutralisationArme
                : null,
            lieuNeutralisation: dataSignalerArmeManquante.isNeutralisee
                ? dataSignalerArmeManquante.lieuNeutralisationArme
                : null,
            elementsArmeInfos: listeElementArmeManquante,
        };

        try {
            await postApi(
                usagerClientReducer,
                API_AJOUTER_ARME_MANQUANTE,
                detenteurArmeManquanteInput,
                CONTEXT_AJOUTER_ARME_MANQUANTE,
            );
        } finally {
            setIsSubmitting(false);
        }
    };

    useEffect(() => {
        reinitialiseApi(CONTEXT_AJOUTER_ARME_MANQUANTE);
        return () => {
            reinitialiseApi(CONTEXT_AJOUTER_ARME_MANQUANTE);
        };
    }, []);

    useEffect(() => {
        if (isLoadingArmeManquanteAjout === false && messageReponse) {
            finEtape();
        }
    }, [messageReponse]);

    return (
        <Container fluid={false}>
            {isSubmitting && <LoaderMi taille="lg" />}
            {!isSubmitting && (
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col col={12}>
                            <h2>Information de l&apos;arme</h2>
                        </Col>
                    </Row>
                    <Row>
                        <Col col={12}>
                            <p>
                                L&apos;arme suivante va être déclarée et intégrée à votre râtelier
                                numérique :
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col col={12}>
                            <SimpleTable entete={header} donnees={[dataArmeManquanteDisplay]} />
                        </Col>
                    </Row>
                    <BoutonEtape
                        actionPrecedente={etapePrecedente}
                        labelBtnPrecedent="Revenir à l'étape précédente"
                        labelBtnSuivant="Valider"
                        nameBtnSuivant="validerArmeManquante"
                        btnSuivantDisabled={false}
                    />
                </form>
            )}
        </Container>
    );
};

SignalerArmeManquanteEtape2.propTypes = {
    postApi: PropTypes.func.isRequired,
    reinitialiseApi: PropTypes.func.isRequired,
    dataSignalerArmeManquante: PropTypes.shape({
        nouveauNumeroRga: PropTypes.string.isRequired,
        dateAcquisitionArme: PropTypes.string,
        isNeutralisee: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
        dateNeutralisationArme: PropTypes.string,
        lieuNeutralisationArme: PropTypes.string,
        hasNumeroSerie: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
        nouveauNumeroSerie: PropTypes.string,
    }).isRequired,
    etapePrecedente: PropTypes.func.isRequired,
    dataReferentielElementArme: PropTypes.shape({
        typeElementArmeReferentielArme: PropTypes.array.isRequired,
    }).isRequired,
    dataGdr: PropTypes.shape({
        numeroRGA: PropTypes.string,
        type: PropTypes.string,
        marque: PropTypes.string,
        modele: PropTypes.string,
        classementFrancais: PropTypes.string,
        canonUn: PropTypes.shape({
            libelleCalibre: PropTypes.string,
        }),
        canonDeux: PropTypes.shape({
            libelleCalibre: PropTypes.string,
        }),
    }),
    isLoadingArmeManquanteAjout: PropTypes.bool.isRequired,
    messageReponse: PropTypes.string.isRequired,
    etapeSuivante: PropTypes.func.isRequired,
};

export default connect(
    (state) => {
        const { data: dataReferentielElementArme } = state.referentiel.elementsArme;
        const { data: dataGdr } = state.armes.recupererGdrParNumeroRga;
        const { isLoading: isLoadingArmeManquanteAjout, message: messageReponse } =
            state.armes.ajouterArmeManquante;

        return {
            dataReferentielElementArme,
            dataGdr,
            isLoadingArmeManquanteAjout,
            messageReponse,
        };
    },
    {
        postApi: postAPI,
        reinitialiseApi: reinitialiseAPI,
    },
)(SignalerArmeManquanteEtape2);
